import {
  collection,
  doc,
  addDoc,
  setDoc,
  deleteDoc,
  getDocs,
  query,
  where,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "./firebase";

export const EQUIPMENT_LIST = [
  { key: "barbell",         label: "Barbell" },
  { key: "rack",            label: "Squat Rack / Power Rack" },
  { key: "dumbbell",        label: "Dumbbells" },
  { key: "bench",           label: "Bench" },
  { key: "cable",           label: "Cable Machine" },
  { key: "pullup_bar",      label: "Pull-up Bar" },
  { key: "resistance_band", label: "Resistance Bands" },
  { key: "kettlebell",      label: "Kettlebell" },
  { key: "machine",         label: "Weight Machines" },
  { key: "trx",             label: "TRX / Suspension Trainer" },
];

export async function getAllWorkoutPrograms() {
  const snap = await getDocs(collection(db, "workoutPrograms"));
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

// Fetches programs visible to a specific user:
//   - programTags[] contains the user's programTag
//   - OR targetUserIds[] contains the user's uid
// Merges and deduplicates results.
export async function getWorkoutPrograms(programTag, userId) {
  const results = new Map();

  const addResults = (snap) => {
    snap.docs.forEach((d) => {
      if (!results.has(d.id)) results.set(d.id, { id: d.id, ...d.data() });
    });
  };

  const promises = [];

  if (programTag) {
    promises.push(
      getDocs(
        query(
          collection(db, "workoutPrograms"),
          where("programTags", "array-contains", programTag),
          where("active", "==", true)
        )
      ).then(addResults)
    );
  }

  if (userId) {
    promises.push(
      getDocs(
        query(
          collection(db, "workoutPrograms"),
          where("targetUserIds", "array-contains", userId),
          where("active", "==", true)
        )
      ).then(addResults)
    );
  }

  await Promise.all(promises);
  return [...results.values()];
}

export async function createWorkoutProgram(data) {
  return await addDoc(collection(db, "workoutPrograms"), {
    ...data,
    programTags: data.programTags || [],
    targetUserIds: data.targetUserIds || [],
    createdAt: serverTimestamp(),
  });
}

export async function updateWorkoutProgram(id, data) {
  await setDoc(doc(db, "workoutPrograms", id), data, { merge: true });
}

export async function deleteWorkoutProgram(id) {
  await deleteDoc(doc(db, "workoutPrograms", id));
}
